import { FC, ReactNode } from 'react';

import { useAuthQuery } from '../../auth/hooks/useAuthQuery';

/** Compatibility surface for legacy ride components during the auth query migration. */
export const AuthProvider: FC<{ children: ReactNode }> = ({ children }) => <>{children}</>;

export const useAuth = useAuthQuery;
